"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconCross', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M9.41,8l3.3-3.29a1,1,0,1,0-1.42-1.42L8,6.59,4.71,3.29A1,1,0,0,0,3.29,4.71L6.59,8l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L8,9.41l3.29,3.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M11.41425,10.00025 L16.70725,4.70725 C17.09825,4.31625 17.09825,3.68425 16.70725,3.29325 C16.31625,2.90225 15.68425,2.90225 15.29325,3.29325 L10.00025,8.58625 L4.70725,3.29325 C4.31625,2.90225 3.68425,2.90225 3.29325,3.29325 C2.90225,3.68425 2.90225,4.31625 3.29325,4.70725 L8.58625,10.00025 L3.29325,15.29325 C2.90225,15.68425 2.90225,16.31625 3.29325,16.70725 C3.48825,16.90225 3.74425,17.00025 4.00025,17.00025 C4.25625,17.00025 4.51225,16.90225 4.70725,16.70725 L10.00025,11.41425 L15.29325,16.70725 C15.48825,16.90225 15.74425,17.00025 16.00025,17.00025 C16.25625,17.00025 16.51225,16.90225 16.70725,16.70725 C17.09825,16.31625 17.09825,15.68425 16.70725,15.29325 L11.41425,10.00025 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
}), _SVGIconWithSizes)));

exports.default = _default;